"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  addDimensions: true,
  getAnalyticsClickHandler: true,
  initDimensionsFromState: true,
  trackAnalyticsEvent: true,
  trackEventFromState: true,
  trackEventFromStateOnPageUnload: true,
  trackInitialPageView: true,
  middleware: true,
  GA_SETTINGS_PROP_TYPE: true,
  GA_SETTINGS_PROP_FIXTURE: true,
  postAnalyticsAction: true
};
Object.defineProperty(exports, "addDimensions", {
  enumerable: true,
  get: function get() {
    return _utils.addDimensions;
  }
});
Object.defineProperty(exports, "getAnalyticsClickHandler", {
  enumerable: true,
  get: function get() {
    return _utils.getAnalyticsClickHandler;
  }
});
Object.defineProperty(exports, "initDimensionsFromState", {
  enumerable: true,
  get: function get() {
    return _utils.initDimensionsFromState;
  }
});
Object.defineProperty(exports, "trackAnalyticsEvent", {
  enumerable: true,
  get: function get() {
    return _utils.trackAnalyticsEvent;
  }
});
Object.defineProperty(exports, "trackEventFromState", {
  enumerable: true,
  get: function get() {
    return _utils.trackEventFromState;
  }
});
Object.defineProperty(exports, "trackEventFromStateOnPageUnload", {
  enumerable: true,
  get: function get() {
    return _utils.trackEventFromStateOnPageUnload;
  }
});
Object.defineProperty(exports, "trackInitialPageView", {
  enumerable: true,
  get: function get() {
    return _utils.trackInitialPageView;
  }
});
Object.defineProperty(exports, "middleware", {
  enumerable: true,
  get: function get() {
    return _middleware.default;
  }
});
Object.defineProperty(exports, "GA_SETTINGS_PROP_TYPE", {
  enumerable: true,
  get: function get() {
    return _constants.GA_SETTINGS_PROP_TYPE;
  }
});
Object.defineProperty(exports, "GA_SETTINGS_PROP_FIXTURE", {
  enumerable: true,
  get: function get() {
    return _fixtures.GA_SETTINGS_PROP_FIXTURE;
  }
});
Object.defineProperty(exports, "postAnalyticsAction", {
  enumerable: true,
  get: function get() {
    return _postAnalyticsAction.postAnalyticsAction;
  }
});

var _utils = require("./utils");

var _middleware = _interopRequireDefault(require("./middleware"));

var _constants = require("./constants");

var _fixtures = require("./fixtures");

var _analyticsModel = require("./analyticsModel");

Object.keys(_analyticsModel).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _analyticsModel[key];
    }
  });
});

var _postAnalyticsAction = require("./post-analytics-action");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
//# sourceMappingURL=index.js.map